"use client";

import posthog from "posthog-js";
import type { AnalyticsEvent, AnalyticsEventPayload } from "@/lib/analytics/events";

function isPosthogReady() {
  return typeof window !== "undefined";
}

export function captureClientEvent(event: AnalyticsEvent, payload?: AnalyticsEventPayload) {
  if (!isPosthogReady()) return;
  try {
    posthog.capture(event, payload);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Posthog capture failed", error);
    }
  }
}

export function identifyClientUser(distinctId: string, properties?: Record<string, unknown>) {
  if (!isPosthogReady()) return;
  try {
    posthog.identify(distinctId, properties);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Posthog identify failed", error);
    }
  }
}

export function resetClientAnalytics() {
  if (!isPosthogReady()) return;
  try {
    posthog.reset();
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Posthog reset failed", error);
    }
  }
}
